<template>
  <div class="home">
    <navigaTion></navigaTion>
      <!-- 顶部 -->
    <div class="header">
      <div class="banner">
        <!-- 顶部左侧 -->
          <div class="headerLeft">
            <img src="@/assets/home/Préstamos efectivo.png" alt="" width="475px">
            <div class="line"></div>
            <ul>
              <div class="title">
                <span>Ventajas del producto</span>
                <img src="@/assets/home/curve.png" alt="" width="50px" height="48px">
              </div>
              <li>> Cero umbral,sin garantía.</li>
              <li>> Verificación rápida sin necesitar espear mucho tiempo.</li>
              <li>> Verificación en línea las 24 horas,los préstamos se realizan en cualquier lugar y en cualquier momento.</li>
              <li>> Tasa de interés transparente: Tasa de interés máxima anual (%): 24%</li>
              <li>> Seguridad de la información, múltiples protecciones de privacidad para evitar la revelación.</li>
            </ul>
            <div class="HeaderBottom">
              <!-- 顶部左侧下载图片 -->
              <a target="_blank" href="https://boutiqueprice.com/a">
                <img src="@/assets/home/download.png" alt="">
              </a>
              <a target="_blank" href="https://boutiqueprice.com/i">
                <img src="@/assets/home/IOSDownload.png" alt="">
              </a>
            </div>
          </div>
          <!-- 顶部右侧图 -->
          <div class="headerRight">
            <img src="@/assets/home/header.png" alt="">
          </div>
      </div>
    </div>
    <div class="loanSimula">
      <div class="banner">
        <div class="left">
          <div class="title">Simula tu préstamo</div>
          <div class="input">
            Monto que necesitas:
            <input type="text" v-model="loanAmount" placeholder="De $100a$10,000" />
          </div>
          <div class="stages">
            ¿En cuántos pagos?:
            <ul>
              <li :class="{active:numberInstallments===1}" @click="numberInstallments=1">1</li>
              <li :class="{active:numberInstallments===2}" @click="numberInstallments=2">2</li>
              <li :class="{active:numberInstallments===3}" @click="numberInstallments=3">3</li>
              <li :class="{active:numberInstallments===4}" @click="numberInstallments=4">4</li>
            </ul>
          </div>
          <div class="btn" @click="handleInput">Comenzar a calcular</div>
        </div>
        <div class="right">
          <div class="right-content">
            <div class="title">Plan de reembolso</div>
            <ul>
              <li v-for="(item,index) in SimulaResult" :key="item.time">
                <span class="n">0{{ index+1 }}</span>
                <span class="time">{{ item.time || '' }}</span>
                <span class="line"></span>
                <span class="importe">Importe pendiente：</span>
                <span class="money">{{ item.money || '' }}</span>
              </li>
              <!-- <li>
                <span class="n">02</span>
                <span class="time">{{ SimulaResult[1].time || '' }}</span>
                <span class="line"></span>
                <span class="importe">Importe pendiente：</span>
                <span class="money">{{ SimulaResult[1].money || '' }}</span>
              </li>
              <li>
                <span class="n">03</span>
                <span class="time">{{ SimulaResult[2].time || '' }}</span>
                <span class="line"></span>
                <span class="importe">Importe pendiente：</span>
                <span class="money">{{ SimulaResult[2].money || '' }}</span>
              </li>
              <li>
                <span class="n">04</span>
                <span class="time">{{ SimulaResult[3].time || '' }}</span>
                <span class="line"></span>
                <span class="importe">Importe pendiente：</span>
                <span class="money">{{ SimulaResult[3].money || '' }}</span>
              </li> -->
            </ul>
          </div>
        </div>
      </div>
    </div>
      <!-- 介绍 -->
    <div class="introduce">
      <div class="banner">
        <h2>Pide prestado y devuelve en cualquier momento con una cuota revolvente</h2>
        <ul>
          <div class="dashed"></div>
          <li class="loan-content">
            <img src="@/assets/home/record.png" alt="">
            <div class="text">
              <h4>Registrarse y verificar</h4>
              <p>Debe registrarse y completar la información requerida para terminar la verificación.</p>
            </div>
            <ul class="loan-list">
              <li>
                <img src="@/assets/home/check.png" alt="">
                <span>Número teléfonico de México</span>
              </li>
              <li>
                <img src="@/assets/home/check.png" alt="">
                <span>INE vigente</span>
              </li>
              <li>
                <img src="@/assets/home/check.png" alt="">
                <span>Ser mayor de 18 años</span>
              </li>
              <li>
                <img src="@/assets/home/check.png" alt="">
                <span>Tener su propia cuenta bancaria</span>
              </li>
              <li>
                <img src="@/assets/home/check.png" alt="">
                <span>Historial crediticio</span>
              </li>
            </ul>
          </li>
          <li>
            <img src="@/assets/home/proving.png" alt="">
            <div class="text">
              <h4>Solicitar préstamos</h4>
              <p>Puede elegir el monto y el plazo de préstamos de acuerdo con sus necesidades y agregar una cuenta para recibir el dinero. Puede solicitar préstamos y ver los resultados de las verificaciones..</p>
            </div>
          </li>
          <li>
            <img src="@/assets/home/fast.png" alt="">
            <div class="text">
              <h4>Obtención de préstamos</h4>
              <p>Completamos el proceso de verificación en 3 minutos. Si se aprueba, el dinero se acreditará de inmediato.</p>
            </div>
          </li>
          <li>
            <img src="@/assets/home/repayment.png" alt="">
            <div class="text">
              <h4>Pagar el préstamo a tiempo</h4>
              <p>Para aumentar el límite de crédito y evitar multas, debe pagar a tiempo los préstamos antes de las fechas de vencimiento.</p>
            </div>
          </li>
          <li>
            <img src="@/assets/home/circulate.png" alt="">
            <div class="text">
              <h4>Volver a pedier préstamos</h4>
              <p>Nos complace ayudarlo a alcanzar la vida de su sueño y esperamos poder brindarle ayuda nuevamente.</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 联系方式 -->
    <div class="contact">
      <div class="content">
        <!-- 联系方式左侧标题 -->
        <div class="contactLeft">Atención al cliente</div>
        <div class="contactRight">
          <!-- 联系方式右侧手机号等 -->
          <ul>
            <li>
              <div class="iconLeft">
                <img src="@/assets/home/phone.png" alt="">
              </div>
              <div class="iconRight">
                <h6>Llame a la línea directa de servicio al cliente</h6>
                <p>+52 5589578400</p>
              </div>
            </li>
            <!-- <li>
              <div class="iconLeft">
                <img src="@/assets/home/WeChat.png" alt="">
              </div>
              <div class="iconRight">
                <h6>Whats App</h6>
                <p>+52 5574067350</p>
              </div>
            </li> -->
            <li>
              <div class="iconLeft">
                <img src="@/assets/home/mailbox.png" alt="">
              </div>
              <div class="iconRight">
                <h6>Correo electrónico de servicio al cliente</h6>
                <p>contacto@boutiqueprice.com</p>
              </div>
            </li>
            <!-- <li>
              <div class="iconLeft">
                <img src="@/assets/home/phone.png" alt="">
              </div>
              <div class="iconRight">
                <h6>Hotline de quejas</h6>
                <p>+52 5589578400</p>
              </div>
            </li> -->
          </ul>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="footer">
      <div class="banner">
        <!-- 底部左侧logo -->
        <a href="#" class="logo" @click="goHome">
          <img src="@/assets/home/logo2.png" alt="">
          <span>Préstamo Boutique</span>
        </a>
        <!-- cat -->
        <div class="cat" id="cat">
          <h3>CAT：</h3>
          <p>
            <span>-Límite de crédito: Desde $800 hasta $50,000 pesos</span>
            <span>-Duración: 91 a 120 días</span>
            <span>-Tasa de interés máxima anual (%): 24%</span>
            <span>-IVA: 16%</span>
            <span>-Comisión por contratación o apertura 24% del monto total del crédito</span>
            <span>-CAT informativo:228%;</span>
            <span>Para un préstamo de $2,000 a pagar en 120 días, tendrás que pagar solo $158 (2000*24%*120/365=158) de interés, una comisión por contratación o apertura $480 (2000*24%=480) e IVA (158+480) *16%=102 pesos. El monto total a pagar sería de $2000+158+480+102=$2740 pesos.</span>
          </p>
        </div>
        <!-- 底部地址 -->
        <div class="address">
          <h3>Dirección</h3>
          <p> Rio Churubusco, Colonia Xoco, Alcaldía Benito Juárez, <br>
            CP 03330 Ciudad de México
          </p>
          <!-- 取消精品账户 -->
          <div class="cancelBoutique" @click="$router.push({name: 'cancelBoutique'})">
            <span>
              Cancelar la cuenta de Boutique
            </span>
          </div>
          <a @click="goAgreement('user')" > {{userServiceAgreement}} </a>
          <a @click="goAgreement('Privacy')">  {{privacyPolicy}} </a>
          <div class="btns">
            <div class="btn" @click="show = true">Contact condusef</div>
            <div class="btn btn2" @click="gotoLetreroUNE">UNE-BTQ Tesoro</div>
            <div class="btn" @click="gotoEntidades">Buró de Entidades Financieras</div>
          </div>
        </div>
        <!-- 底部右侧gp下载 -->
        <div class="footerIcon">
          <a target="_blank" href="https://www.buro.gob.mx/">
            <img src="@/assets/home/footer-icon1.png" alt="">
          </a>
          <a target="_blank" href="https://www.condusef.gob.mx/#">
            <img src="@/assets/home/footer-icon2.png" alt="">
          </a>
        </div>
        <!-- 底部右侧gp下载 -->
        <div class="footerDownload">
          <a target="_blank" href="https://boutiqueprice.com/a">
            <img src="@/assets/home/download.png" alt="">
          </a>
          <a target="_blank" href="https://boutiqueprice.com/i">
            <img src="@/assets/home/IOSDownload.png" alt="">
          </a>
        </div>
      </div>
      <div class="pre-info" ref="preInfo" style="">
        <h3>Presentación de la empresa</h3>
        <p>BTQ Tesoro, S.A.P.I. de C.V., SOFOM E.N.R., para su constitución y operación con carácter de sociedad financiera de objeto múltiple, entidad no regulada, no requieren autorización de la Secretaría de Hacienda y Crédito Público y únicamente está sujeta a la supervisión de la Comisión Nacional Bancaria y de Valores para afectos del artículo 56 de la Ley General de Organizaciones y Actividades Auxiliares del Crédito</p>
      </div>
      <!-- 底部下方版权号 -->
      <div class="bottom">BTQ TESORO SAPI DE CV SOFOM ENR.</div>
    </div>
    <van-popup v-model="show" class="condusef-popup">
      <img src="@/assets/home/close.png" alt="" @click="show = false">
      <div class="title">CONDUSEF</div>
      <p class="des1">Comision Nacional para la Proteccion y Defensa de los Usuarios de Servicios Financieros</p>
      <p class="des2">Centro de Atencion Telefonica：</p>
      <p class="des3">53-40-09-99</p>
      <p class="des4"> <a href="https://www.condusef.gob.mx" target="_blank">www.condusef.gob.mx</a></p>
    </van-popup>
  </div>
</template>

<script>
export default {
  data () {
    return {
      userServiceAgreement: '<Acuerdo de Servicio al Usuario>',
      privacyPolicy: '<Política de Privacidad>',
      show: false,
      loanAmount: '1000',
      numberInstallments: 4, // 分期数
      SimulaResult: [{}, {}, {}, {}]
    }
  },
  created () {
    window.scroll(0, 0)
  },
  mounted () {
    const p = document.getElementById('cat').offsetLeft
    this.$refs.preInfo.style = 'padding-left:' + p + 'px'
    this.handleInput()
  },
  watch: {
    loanAmount: {
      handler (newVal) {
        this.loanAmount = this.loanAmount.replace(/[^0-9]/g, '')
        if (!this.loanAmount) {
          this.setDefault()
        }
      },
      immediate: true
    },
    numberInstallments () {
      this.handleInput()
    }
  },
  methods: {
    goHome () {
      if (this.$route.name === 'Home') {
        location.reload()
      } else {
        this.$router.replace({ name: 'Home' })
      }
    },
    goAgreement (name) {
      this.$router.push({ name: 'agreement', query: { name } })
    },
    gotoLetreroUNE () {
      this.$router.push({ name: 'letreroUNE' })
    },
    gotoEntidades () {
      this.$router.push({ name: 'entidades' })
    },
    to2 (num) {
      return num.toString().padStart(2, '0')
    },
    setDefault () {
      const myDate = new Date()
      let month = myDate.getMonth() + 1
      let day = myDate.getDate()
      let year = myDate.getFullYear()
      const SimulaResult = []
      for (let i = 1; i <= this.numberInstallments; i++) {
        myDate.setDate(day + 90)
        month = myDate.getMonth() + 1
        day = myDate.getDate()
        year = myDate.getFullYear()
        SimulaResult.push({
          time: `${this.to2(month)}-${this.to2(day)}-${year}`,
          money: ''
        })
      }
      this.SimulaResult = SimulaResult
    },
    handleInput () {
      const myDate = new Date()
      let month = myDate.getMonth() + 1
      let day = myDate.getDate()
      let year = myDate.getFullYear()

      this.loanAmount = this.loanAmount.replace(/[^0-9]/g, '')
      if (!this.loanAmount) {
        this.setDefault()
        return
      }
      if (this.loanAmount) {
        const SimulaResult = []
        // 额 每一期90天
        // 然后每期计算公式是 （借款金额*期数*90*0.004）/4是每一期的利息
        // 然后每一期还款金额就是 借款金额/4+每期利息
        const interest = (this.loanAmount * 0.0004 * (90 * this.numberInstallments)) / 4// 利息
        const money = '$' + Math.floor(this.loanAmount / this.numberInstallments + interest)
        for (let i = 1; i <= this.numberInstallments; i++) {
          myDate.setDate(day + 90)
          month = myDate.getMonth() + 1
          day = myDate.getDate()
          year = myDate.getFullYear()
          SimulaResult.push({
            time: `${this.to2(month)}-${this.to2(day)}-${year}`,
            money: money
          })
        }
        console.log(SimulaResult)
        this.SimulaResult = SimulaResult
      } else {
        this.SimulaResult = [{}, {}, {}, {}]
      }
    }
  }

}
</script>

<style scoped lang="less">
.home {
  text-align: left;
}
.banner {
  width: 1100px;
  height: 100%;
  margin: auto;
}
.header {
  height: 660px;
  background-color: #272C2B;
  .banner {
    display: flex;
    justify-content: space-between;
  }
  .headerLeft {
    flex: 1;
    padding-top: 75px;
    .line {
      width: 176px;
      height: 1px;
      margin: 26px 0 41px;
      background-color: #F3F3F3;
    }
    ul {
      .title {
        display: flex;
        justify-content: space-between;
        color: #DDDDDD;
        padding-right: 60px;
        font-size: 24px;
        margin-bottom: 5px;
      }
      li {
        color: #D8D8D8;
        font-size: 14px;
        width: 420px;
        margin-bottom: 15px;
        text-align: left;
      }
    }
    .HeaderBottom {
      margin-top: 40px;
      display: flex;
      align-items: center;
      font-size: 0;
      .botton {
        width: 270px;
        height: 60px;
        border-radius: 60px;
        text-align: center;
        line-height: 60px;
        background-color: #E7FE48;
        color: #000;
        font-size: 14px;
      }
      img {
        width: 108px;
        height: 34px;
        margin-right: 40px;
      }
    }
  }
  .headerRight {
    width: 600px;
    height: 625px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.loanSimula{
  background: #212121;
  padding-top: 50px;
  padding-bottom: 50px;
  .banner{
    display: flex;
    column-gap: 80px;
    align-items: end;
    height: 408px;
  }
  .left{
    width: 444px;
    .title{
      font-size: 44px;
      font-weight: 600;
      color: #E0E0E0;
    }
    .input{
      font-size: 24px;
      font-weight: 400;
      color: #FFFFFF;
      margin-top: 13px;
      input{
        font-size: 24px;
        background: #212121;
        border-radius: 18px;
        border: 1px solid #D8D8D8;
        padding:15px 20px;
        display: block;
        width: 100%;
        margin-top: 5px;
      }
    }
    .stages{
      font-weight: 400;
      font-size: 28px;
      color: #FFFFFF;
      margin-top: 20px;
      ul{
        display: flex;
        column-gap: 27px;
        margin-top: 10px;
        li{
          background: #3C4543;
          border-radius: 11px;
          width: 63px;
          height: 48px;
          text-align: center;
          line-height: 48px;
          cursor: pointer;
        }
        li.active{
          background: #79CD46;
        }
      }
    }
    .btn{
      margin-top: 45px;
      border-radius: 18px;
      background: #79CD46;
      height: 68px;
      line-height: 68px;
      font-size: 28px;
      font-weight: 600;
      color: #FFFFFF;
      text-align: center;
      cursor: pointer;
    }
  }
  .right{
    flex: 1;
    .right-content{
      padding: 34px 34px 40px 34px;
      background: #272C2B;
      border-radius: 30px;
      margin-top: 50px;
    }
    .title{
      font-weight: 500;
      font-size: 30px;
      color: #FFFFFF;
    }
    ul{
      margin-top: 40px;
      font-size: 20px;
      font-weight: 400;
      color: #D8D8D8;
      position: relative;
      &::before{
        content: '';
        position: absolute;
        border-left: 1px dashed #979797;
        height: calc(100% - 50px);
        left:183px;
        top: 30px;
        z-index: 1;
      }
      li{
        display: flex;
        align-items: center;
        position: relative;
        z-index: 2;
        margin-top: 20px;
        span{
          display: inline-block;
        }
        .n{
          font-weight: 600;
          font-size: 28px;
          color: #FFFFFF;
          margin-right: 6px;
          width: 33px;
          white-space: nowrap;
        }
        .time{
          width: 120px;
          white-space: nowrap;
        }
        .line{
          margin-left: 15px;
          margin-right: 6px;
          background-image: url('@/assets/home/loan-icon1.png');
          background-size: 100% 100%;
          width: 20px;
          height: 20px;
          background-repeat: no-repeat;
        }
        .money{
          font-weight: 600;
          font-size: 24px;
          color: #FFFFFF;
          width: 109px;
        }
      }
    }
  }
}
.introduce {
  background-color: #272C2B;
  min-height: 920px;
  padding-bottom: 90px;
  h2 {
    width: 900px;
    font-size: 44px;
    color: #E0E0E0;
    padding: 65px 0;
    text-align: left;
  }
  .banner{
    > ul {
      position: relative;
      .dashed {
        position: absolute;
        top: 60px;
        left: 30px;
        width: 0;
        height: calc(100% - 66px);
        border-left: 2px dashed #E7FE48;
        z-index: 1;
      }
      > li {
        display: flex;
        color: #D8D8D8;
        font-size: 17px;
        margin-bottom: 77px;
        text-align: left;
        position: relative;
        &:last-child{
          margin-bottom: 0;
        }
        h4 {
          font-weight: 700;
        }
        img {
          width: 60px;
          height: 60px;
          margin-right: 50px;
          z-index: 2;
        }
      }
    }
    .loan-content{
      padding-bottom: 180px;
    }
    .loan-list{
      position: absolute;
      left: 110px;
      top: 70px;
      li{
        margin-bottom: 16px;
        font-size: 16px;
        color: #D8D8D8;
        font-weight: 400;
        display: flex;
        align-items: end;
      }
      img{
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
    }
  }
}
.contact {
  height: 390px;
  background-color: #282c2b;
  padding-top: 56px;
  .content {
    width: 1127px;
    height: 288px;
    margin: auto;
    background-image: url('@/assets/home/联系方式背景图.png');
    background-size: cover;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 100px;
    .contactLeft {
      color: #FFFFFF;
      font-size: 45px;
      // width: 288px;
    }
    .contactRight {
      ul {
        display: flex;
        flex-wrap: wrap;
        width: 300px;
        li {
          text-align: left;
          display: flex;
          // width: 320px;
          width: 100%;
          height: 50px;
          color: #FFFFFF;
          font-size: 15px;
          // &:nth-child(1),
          &:nth-child(2) {
            margin-top: 44px;
          }
          h6 {
            font-size: 12px;
            margin-bottom: 10px;
          }
          img{
            width: 36px;
            height: 36px;
            margin-right: 15px;
          }
        }
      }
    }
  }
}
.footer {
  background-color: #000;
  color: #D8D8D8;
  .banner {
    display: flex;
    padding-top: 26px;
    padding-bottom: 40px;
    justify-content: space-between;
    position: relative;
    .logo {
      height: 32px;
      display: flex;
      align-items: center;
      color: #D8D8D8;
      img {
        width: 32px;
        height: 32px;
        margin-right: 5px;
      }
      span {
        font-size: 12px;
      }
    }
  }
  .cat{
    width: 442px;
    font-weight: 400;
    font-size: 12px;
    color: #D8D8D8;
    span{
      display: block;
    }
    h3{
      font-size: 18px;
    margin-bottom: 12px;
    }
  }
  .address {
    text-align: left;    font-size: 0;
    h3 {
      font-size: 16px;
      font-weight: 400;
      margin-bottom: 12px;
    }
    p {
      font-size: 12px;
    }
    a{
      font-size: 12px;
      display: inline-block;
      border-bottom: 1px solid #D8D8D8;
      color: #fff;
        cursor: pointer;
    }
    .cancelBoutique {
      margin-bottom: 10px;
      span {
        color: #E7FE48;
        font-size: 12px;
        border: 1px solid #E7FE48;
        border-radius: 21px;
        width: 200px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        margin-top: 20px;
        display: block;
        cursor: pointer;
      }
    }
    .cancelBoutique + a{
      margin-right: 5px;
    }
    .btns{
      white-space: nowrap;
      .btn{
        display: inline-block;
        font-weight: 400;
        font-size: 12px;
        color: #E7FE48;
        margin-top: 20px;
        text-decoration-line: underline;
          cursor: pointer;
        &.btn2{
          margin-left: 10px;
          margin-right: 10px;
        }
      }
    }
  }
  .footerIcon{
    a {
      display: block;
      width: auto;
      height: 31px;
      font-size: 0;
      margin:0 auto;
      text-align: center;
      &:last-child {
        width: auto;
        height: 36px;
        margin-top: 30px;
      }
      img {
        width: auto;
        height: 100%;
      }
    }
  }
  .footerDownload {
    a {
      display: block;
      width: 98px;
      height: 31px;
      font-size: 0;
      &:last-child {
        margin-top: 30px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .pre-info{
    border-top: 1px solid #434343;
    padding-top: 35px;
    padding-bottom: 40px;
    font-size: 18px;
    font-weight: 400;
    width: 1100px;
    margin: auto;

    h3 {
      margin-bottom: 12px;
      color: #D8D8D8;
    }
    p{
      font-size: 12px;
    }
  }
  .bottom {
    border-top: 1px solid #434343;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 12px;
  }
}
.condusef-popup{
  padding: 30px;
  padding-top: 38px;
  border-radius: 30px;
  color: #222222;
  font-weight: 400;
  font-size: 20px;
  img{
    position: absolute;
    right: 30px;
    top: 30px;
    width: 32px;
    height: 32px;
    cursor: pointer;
  }
  .title{
    font-weight: 600;
    font-size: 40px;
    padding-bottom: 29px;
    margin-bottom: 29px;
    border-bottom: 1px solid #D9DDD6;
  }
  .des1{
    font-weight: 600;
  }
  .des2{
    margin-top: 26px;
  }
  .des3{
    margin-top: 26px;
  }
  .des4{
    margin-top: 26px;
    a{
  color: #222222;
    }
  }
}
</style>
